import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeIsNewCustomer } from '../../../redux/selectors/member';
import {
  makeDataByKey,
  makeIsNewFetching,
  makeProductIdsSelector,
} from '../../../redux/selectors/onboarding';
import OnboardingTitle from './OnboardingTitle';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isFetching: makeDataByKey('isFetching'),
    loadingType: makeDataByKey('listLoadingType'),
    isNewCustomer: makeIsNewCustomer(),
    isNewFetching: makeIsNewFetching(),
    onBoardingIdList: makeProductIdsSelector({ count: 10 }),
  });

  return state => selector(state);
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingTitle);
